module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_type.88861f1a.png";